import { MdBedroomParent } from "react-icons/md";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "microContentSuiteClass",
  title: "Suite Class",
  type: "document",
  icon: MdBedroomParent,

  fields: [
    defineField({
      name: "imageDisclaimer",
      title: "Image Disclaimer",
      type: "multilingualArrayBlockContent"
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Suite Class"
      };
    }
  }
});
